import { t } from 'i18next';
import * as yup from 'yup';


export const SignInSchema = yup.object().shape({
	email: yup.string().required(),
	password: yup.string().required(),
});


export const MemberScheme = yup.object().shape({
	name: yup.string().required(t('auth.member.errorMessage')),
	surname: yup.string().required(t('auth.member.errorMessage')),
	email: yup.string().required(t('auth.member.errorMessage')),
	company: yup.string().required(t('auth.member.errorMessage')),
	country: yup.string().required(t('auth.member.errorMessage')),
	engagement: yup.string().required(t('auth.member.errorMessage')),
	isLead: yup.string().required(t('auth.member.errorMessage')),
	leadMore: yup.string().when('isLead', {
		is: 'yes',
		then: schema => schema.required(t('auth.member.errorMessage')),
		otherwise: schema => schema.notRequired(),
	}),
	isRegistered: yup.string().required(t('auth.member.errorMessage')),
});
